import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * search
 */

export type SearchParams = {
  buildingName: string
  roomName: string
}

type SearchResponseData = {
  buildingId: number
  roomId: number
  isDormitory: boolean
}

export const search = async (params: SearchParams) => {
  return await get<SearchResponseData>('/v1/buildings/search', params, false)
}
